// for backwards compat
module.exports = require('json-rpc-engine/src/createScaffoldMiddleware')
